import React from 'react';
import { Modal } from 'antd';
import { Container } from './styles';
import CreateShortMsgTemplate from './CreateShortMsgTemplate';

const CreateShortMsgTempModal = props => {
  const { visible, onCancel, onSucess, template = {}, activeContent,
    categoryId = undefined, resourceGroupId = undefined, communicationId = undefined } = props;

  return (
    <Container onKeyDown={e => e.stopPropagation()}>
      <Modal
        title={'Design a new short message template '}
        centered
        maskClosable={false}
        visible={visible}
        width="625px"
        onCancel={onCancel}
        footer={false}
        className="warning-modal"
      >
        <CreateShortMsgTemplate
          onSucess={onSucess}
          template={template}
          activeContent={activeContent}
          categoryId={categoryId}
          resourceGroupId={resourceGroupId}
          communicationId={communicationId}
        />
      </Modal>
    </Container>
  );
};
export default CreateShortMsgTempModal;
